import { useNavigate } from 'react-router-dom'
import { capitalizeAllLetter, capitalizeFirstLetter } from '../../../utility/genricFunction'
import { useDispatch, useSelector } from 'react-redux'
import dayjs from 'dayjs'
import { studentStartExam } from '../../../store/builders/student/student.builder'
import { UI_CONSTANT } from '../../../utility/constants'

function LectureDetails({ lecture }) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { studentId } = useSelector((state) => state.auth.user.result)
  const lectureDate = lecture?.date?.split('T')[0]

  const lectureStartTime = dayjs(`${lectureDate}T${dayjs(lecture.startTime, 'hh:mmA').format('HH:mm')}`)
  const lectureEndTime = dayjs(`${lectureDate}T${dayjs(lecture.endTime, 'hh:mmA').format('HH:mm')}`)
console.log("lecture", lecture)
  const currentTime = dayjs()
  const isExamActive = currentTime.isAfter(lectureStartTime) && currentTime.isBefore(lectureEndTime) && !lecture?.end_exam
  // const isExamActive = true
  const startExam = () => {
    dispatch(
      studentStartExam({
        startTime: currentTime.format('hh:mm A'),
        studentId,
        timetableId: lecture.lectureTimeTableId,
      }),
    )
    navigate('/student-exam-test')
  }
  return (
    <div className='schedule-detail'>
      <span className='lecture-type-span'>{lecture.type?.split('_').join(' ').toUpperCase()}</span>
      <div className='module-details'>
        <div className='module-details-parents-div'>
          <p>
            {capitalizeFirstLetter(lecture?.course_modules_topic?.[0]?.courseDetails?.courseName)}
            {typeof lecture?.course_modules_topic?.[0]?.courseDetails?.course_exam_format === 'string'
              ? JSON.parse(lecture?.course_modules_topic?.[0]?.courseDetails?.course_exam_format)?.map(
                  (item, index) => (
                    <span className='mcq-span' key={index}>
                      {capitalizeAllLetter(item)}
                    </span>
                  ),
                )
              : lecture?.course_modules_topic?.[0]?.courseDetails?.course_exam_format?.map((item, index) => (
                  <span className='mcq-span' key={index}>
                    {capitalizeAllLetter(item)}
                  </span>
                ))}
          </p>
          <div className='module-details-footer flex'>
            <h2>{lecture?.course_modules_topic?.[0]?.course_module?.courseModuleName}</h2>
            <span className='module-details-time'>
              {lecture.startTime} To {lecture.endTime}
            </span>
          </div>
        </div>

        {lecture?.student_attendances?.length > 0 && (
          <div>
          {lecture?.student_attendances[0]?.is_present ? <p className='attendance-present'>{UI_CONSTANT.ATTENDANCE.PRESENT}</p> : <p className='attendance-absent'>{UI_CONSTANT.ATTENDANCE.ABSENT}</p>}
        </div>
        )}

        {studentId && lecture?.type === 'online_exam' && (
          <button className='attendance-btn' disabled={!isExamActive} type='button' onClick={startExam}>
            {UI_CONSTANT.EXAM_ASSESSMENT.START_EXAM}
          </button>
        )}
      </div>
    </div>
  )
}

export default LectureDetails
